import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Flexed } from '../../../../../styles/GlobalComponents';
import {
  StructureGrayButton,
  StructureNavigation
} from '../../../MyTeamBackofficeStyled';
import {
  Position,
  StructureType
} from '../../../myTeamBackOffice.constants.js';
import { BackOnTopButton, GoBottomButton } from '../../common';
import { useAppSelector } from '../../../../../app/hooks';

const StructureNav = ({ selectTab }) => {
  const { t } = useTranslation('myTeam');
  const { isCanadaRestrictedUser } = useAppSelector(
    (state) => state.auth.userInfo
  );

  return (
    <StructureNavigation>
      <Flexed style={{ width: '100%' }}>
        <GoBottomButton
          position={Position.L}
          label={t('bottom_left')}
          isDisabled={false}
          structureType={StructureType.TRADING}
        />
        <BackOnTopButton />
        {!isCanadaRestrictedUser && (
          <StructureGrayButton
            style={{ width: 50, flex: 'none' }}
            orangeGradient
            onClick={() => selectTab('structure')}>
            {t('add')}
          </StructureGrayButton>
        )}

        <GoBottomButton
          position={Position.R}
          label={t('bottom_right')}
          isDisabled={false}
          structureType={StructureType.TRADING}
        />
      </Flexed>
    </StructureNavigation>
  );
};

export default StructureNav;
